// Runtime constants, not just types: the preload only links @griply/types, so they must live here rather than @griply/utils.
export const ELECTRON_USER_AGENT_MARKER = 'GriplyDesktop';
export const ELECTRON_APP_VERSION_META_NAME = 'app-version';
